import DOMPurify from 'dompurify';
import { t } from '../../../i18n/i18n';
import { parseLineHTML } from '../../../utils/parseLineHTML';
import OpenExternalLinkIcon from '../../../assets/testgroupABM/OpenExternalLinkIcon';

const OptionLink = ({ submittedLink }) => {
  if (!submittedLink) return null;

  return (
    <>
      <span className="font-weight-600 text-xs text-color-item-test-group mt-2">
        {t('MODAL_ANSWER')}
      </span>
      <div className="d-inline p-2 mt-2 w-100 modal-container-text-custom">
        <a
          href={submittedLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-black text-break underline"
        >
          <OpenExternalLinkIcon className="mr-1" />
          {t('OPEN_CHALLENG_SUBMITTED_BY_CANDIDATE')}
        </a>
      </div>
    </>
  );
};

export default OptionLink;
